module.exports = __webpack_public_path__ + "img/Keep Control Glow.cbb35296.png";